import { render } from "./EquipmentSkeleton.vue?vue&type=template&id=8c36ebbc&ts=true"
import script from "./EquipmentSkeleton.vue?vue&type=script&lang=ts"
export * from "./EquipmentSkeleton.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./EquipmentSkeleton.vue?vue&type=style&index=0&id=8c36ebbc&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__